import React, { useEffect, useRef, useState } from "react";

const iconMap = {
    success: "bi bi-check-circle-fill",
    danger: "bi bi-x-circle-fill",
    warning: "bi bi-exclamation-triangle-fill",
    primary: "bi bi-info-circle-fill",
};

export default function Toast({ message, type = "primary", visible=true, setVisible, duration = 5000 }) {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        if (visible && message) {
            const id = message;

            setToasts((prev) => {
                const existingIndex = prev.findIndex((toast) => toast.id === id);
                const newToast = { id, message, type, timestamp: Date.now() };

                if (existingIndex !== -1) {
                    const updated = [...prev];
                    updated[existingIndex] = newToast;
                    return updated;
                }

                return [...prev, newToast];
            });

            setTimeout(() => {
                setToasts((prev) => prev.filter((toast) => toast.id !== id));
                setVisible(false);
            }, duration);
        }
    }, [visible, message, type, setVisible, duration]);

    return (
        <div className="position-fixed top-0 end-0 p-3 d-flex flex-column align-items-end gap-2" style={{ zIndex: 9999, top: "70px" }}>
            {toasts.map((toast) => (
                <ToastItem key={toast.id} toast={toast} duration={duration} />
            ))}
        </div>
    );
}

function ToastItem({ toast, duration }) {
    const toastRef = useRef(null);
    const progressRef = useRef(null);

    useEffect(() => {
        if (toastRef.current && progressRef.current) {
            progressRef.current.style.transition = "none";
            progressRef.current.style.width = "100%";
            void progressRef.current.offsetWidth; 
            progressRef.current.style.transition = `width ${duration}ms linear`;
            progressRef.current.style.width = "0%";

            const toast = window.bootstrap.Toast.getOrCreateInstance(toastRef.current,{
                autohide: false
              });
            toast.show();
        }
    }, [duration]);

    return (
        <div
            ref={toastRef}
            className={`toast text-white bg-${toast.type} `}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{ minWidth: "300px", fontSize: "1rem" }}
        >
            <div className="d-flex align-items-center">
                <div className="toast-body d-flex align-items-center gap-2">
                    <i className={`${iconMap[toast.type]} me-2`}></i>
                    <span>{toast.message}</span>
                </div>
                <button
                    type="button"
                    className="btn-close btn-close-white me-2 m-auto"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                ></button>
            </div>
            <div className="progress">
                <div
                    ref={progressRef}
                    className={`progress-bar bg-${toast.type}`}
                    style={{ height: "5px", width: "100%" }}
                ></div>
            </div>
        </div>
    );
}